import "./Auth.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../components/Logo/Logo";
import ChangeUsername from "../../components/ChangeUsername/ChangeUsername";
import { createUserWithEmailAndPassword, deleteUser } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import { useFirebase } from "../../../contexts/FirebaseContext";
import SharedPageWrapper from "../../components/SharedPageWrapper/SharedPageWrapper";
import { TextField } from "@mui/material";

export default function SignUp() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [status, setStatus] = useState(false);

    const { auth, firestore } = useFirebase();
    const navigate = useNavigate();
    const location = useLocation();

    // Determine game theme from URL params or location state
    const searchParams = new URLSearchParams(location.search);
    const game = searchParams.get('game') || location.state?.game || 'mk8dx';

    const createUser = (e) => {
        e.preventDefault();
        setErrorMessage("");

        if (password !== confirmPassword) {
            setErrorMessage("Passwords don't match");
        } else {
            if (status) {
                createUserWithEmailAndPassword(auth, email, password)
                    .then((user) => {
                        console.log(user.user.uid);
                        try {
                            setDoc(doc(firestore, "users", user.user.uid), { cups: [], displayName: displayName, displayNameLower: displayName.toLowerCase() });
                        } catch (e) {
                            alert(e.message);
                            // delete user if firestore doc can't be created
                            deleteUser(user.user);
                        }
                        navigate("/", { replace: true, state: { yourCup: location.state?.yourCup } });
                    })
                    .catch((error) => setErrorMessage(error.message));
            } else {
                setErrorMessage("Username not validated")
            }
        }
    }

    return <SharedPageWrapper game={game}>
        <div id="auth-container">
            <div id="form-title">
                <Logo game={game} />
                <h1>Sign up</h1>
            </div>

            <form className="auth-form" onSubmit={createUser}>
                
                <h3 id="auth-error">{errorMessage}</h3>
                
                <ChangeUsername
                    displayName={displayName}
                    changeName={setDisplayName}
                    changeStatus={setStatus}
                    uid={null}
                    showChangeButton={false}
                />

                <TextField
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    variant="outlined"
                    className="auth-textfield"
                    sx={{
                        width: '350px',
                        marginBottom: '20px',
                        '& .MuiOutlinedInput-root': {
                            color: 'white',
                            backgroundColor: '#555',
                            '& fieldset': {
                                borderColor: '#777',
                            },
                            '&:hover fieldset': {
                                borderColor: 'white',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: '#aaa',
                            fontFamily: 'var(--ui-font-family)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: 'white',
                        },
                        '& input': {
                            fontFamily: 'var(--ui-font-family)',
                        },
                    }}
                />

                <TextField
                    label="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    autoComplete="new-password"
                    variant="outlined"
                    className="auth-textfield"
                    sx={{
                        width: '350px',
                        marginBottom: '20px',
                        '& .MuiOutlinedInput-root': {
                            color: 'white',
                            backgroundColor: '#555',
                            '& fieldset': {
                                borderColor: '#777',
                            },
                            '&:hover fieldset': {
                                borderColor: 'white',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: '#aaa',
                            fontFamily: 'var(--ui-font-family)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: 'white',
                        },
                        '& input': {
                            fontFamily: 'var(--ui-font-family)',
                        },
                    }}
                />

                <TextField
                    label="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    type="password"
                    autoComplete="new-password"
                    variant="outlined"
                    className="auth-textfield"
                    sx={{
                        width: '350px',
                        marginBottom: '20px',
                        '& .MuiOutlinedInput-root': {
                            color: 'white',
                            backgroundColor: '#555',
                            '& fieldset': {
                                borderColor: '#777',
                            },
                            '&:hover fieldset': {
                                borderColor: 'white',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'white',
                            },
                        },
                        '& .MuiInputLabel-root': {
                            color: '#aaa',
                            fontFamily: 'var(--ui-font-family)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: 'white',
                        },
                        '& input': {
                            fontFamily: 'var(--ui-font-family)',
                        },
                    }}
                />

                <input type="submit" value="Sign Up" className="icon-button" />

            </form>

            <Link onClick={() => navigate(-1)} replace>Have an account already? Sign in</Link>
        </div>
    </SharedPageWrapper>
}